import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';

const rowStyleVst = (record) => {
    if (record && record.status === 'ATTENTE')
        return {
            borderLeftColor: blue[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
    if (record && record.status === 'OK')
        return {

            borderLeftColor: green[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

    if (record && record.status === 'ANNULER')
        return {
         
            borderLeftColor: red[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
    return null;

};

export default rowStyleVst;